import {YesNo} from './CallScreening';

export interface CustomerAgreementCondition {
    i_product: number;
    i_product_group?: number;
    is_addon: number;
    max_offered_quantity: number;
    product_name: string;
    used_quantity: number;
    sub_name?: string;
    unit_name?: string;
    managed_by_user?: YesNo;
    // Unassigned add-on absent from Account/get_allowed_addons: either not managed
    // by users or incompatible with the account's main product (the API does not tell which)
    notInAllowedAddons?: boolean;
}

export enum ThresholdType {
    Time = 'Charged Time',
    Amount = 'Charged Amount'
}

export interface CounterInterface {
    full_discount_info: {
        i_vd_type: number;
        peak_level: number;
    };
    used: string;
    threshold: string;
    usage_period: number;
    unit: string;
    service_ratio: number;
    service_name: string;
    i_service: number;
    dg_name: string;
    period_from: string;
    period_to: string;
    vdp_name: string;
    i_vd_dg: number;
    threshold_type: ThresholdType;
    discount_flag: string;
    remaining: string;
    peak_level: string;
    i_vd_type: number;
    i_vd_plan: number;
}

export interface ConflictingAddon {
    i_product: number;
    is_sf_enabled: number;
    product_name: string;
}

export interface AddonsValidationResults {
    disallowed_products: { i_product: number }[];
    service_features_conflicts: {
        sf_name: string;
        addon_precedence?: string;
        conflicting_addons: ConflictingAddon[];
    }[];
    subscription_conflicts: {
        name: string;
        i_subscription: number;
        addons: ConflictingAddon[];
    }[];
    vdp_conflicts: {
        service_name: string;
        addon_precedence?: string;
        conflicting_vdps: { i_product: number; product_name: string }[];
    }[];
}

// A new object on each call: PlanForm re-checks conflicts on a reference change
export const getEmptyAddonsValidationResults = (): AddonsValidationResults => ({
    disallowed_products: [],
    service_features_conflicts: [],
    subscription_conflicts: [],
    vdp_conflicts: [],
});
